import { Injectable } from '@angular/core';
import { DialogButton, DialogButtonColour, DialogComponent } from '@shared/components/dialog/dialog.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { ModalSetting } from '../modal-setting';

export enum ConfirmationType {
  Positive,
  Destruction
}

export interface ConfirmationDialogOptions {
  confirmLabel?: string;
  cancelLabel?: string;
  title: string;
  message: string;
  type?: ConfirmationType;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
  private modalRef: any;

  constructor(private modalService: BsModalService) { }

  public confirm(
    options: ConfirmationDialogOptions,
    onDecline: () => void,
    confirmAction: Observable<any>,
    onConfirm: () => void) {
    const confirmationColour = options.type === ConfirmationType.Positive ? DialogButtonColour.action : DialogButtonColour.danger
    this.modalRef?.hide();
    const content = {
      title: options.title,
      message: options.message,
      buttons: [
        {
          label: options.cancelLabel || 'No',
          action: of([]),
          complete: () => {
            this.modalRef?.hide();
            onDecline();
          },
          colour: DialogButtonColour.default
        },
        {
          label: options.confirmLabel || 'Yes',
          action: confirmAction,
          complete: () => {
            this.modalRef?.hide();
            onConfirm();
          },
          colour: confirmationColour
        }
      ]
    };
    // Disable Esc dismissal so the dialog can only be closed via its buttons.
    // Backdrop click is already disabled by ModalSetting.createDialog
    // (ignoreBackdropClick: true). Forcing an explicit button click guarantees
    // that either onDecline or onConfirm runs — which callers like the planner's
    // drag-and-drop rely on to either rollback or finalize the card position.
    this.modalRef = this.modalService.show(
      DialogComponent,
      { ...ModalSetting.createDialog(content), keyboard: false }
    );
  }

}